/**
 * Who is signed in, and which team they belong to.
 *
 * The team is not in the access token: team_id and partner_name are Keycloak
 * user attributes and the realm has no mapper for them, so the server reads
 * them with its admin client and answers here.
 */

export interface UserTeam {
  /** The team's Keycloak group id. */
  id: string | null;
  /** Display name of the team, from the partner_name attribute. */
  name: string | null;
}

export interface CurrentUser {
  username: string | null;
  email: string | null;
  /** null when the user has no team attributes set. */
  team: UserTeam | null;
}

const apiBase = () => process.env.REACT_APP_API_URL ?? "";

export async function fetchCurrentUser(authToken: string): Promise<CurrentUser> {
  const response = await fetch(`${apiBase()}/api/v1/me`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  if (!response.ok) throw new Error(`Failed to load the signed-in user (${response.status})`);
  return response.json();
}

/** What to show for a team: its name, else a short form of the group id. */
export function teamLabel(team: UserTeam | null | undefined): string | null {
  if (!team) return null;
  if (team.name) return team.name;
  return team.id ? `${team.id.slice(0, 8)}…` : null;
}
